// RequireAuthor.tsx
import React, { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "../../store/userStore";

export default function RequireAuthor({ children }: { children: JSX.Element }) {
  const role = String(useUserStore((s) => s.user?.role) ?? "").toUpperCase();
  const isAuthor = role === "AUTHOR"|| role === "SUPERADMIN";
  const location = useLocation();
  return isAuthor ? children : <Navigate to="/" state={{ from: location }} replace />;
}
